module.exports = __webpack_public_path__ + "img/1.195a0843.jpg";